import React, { Component } from 'react'
//import styled from 'styled-components'

import { Grommet } from 'grommet/components/Grommet'
import { ModalProvider } from 'styled-react-modal'

import '@assets/css/reset.css'
import '@assets/css/app.css'

import colors from '@constants/colors'
import NavigationRouter from '@navigation/NavigationRouter'
import { useLanguage } from '@state/uses/app'

const grommetTheme = {
    global: {
        colors: {
            brand: colors.COLOR_PRIMARY,
        },
        select: {
            options: {
                container: {
                    zIndex: 1,
                },
            },
        },
    },
}

const __DEV__ = window.location.hostname === 'localhost'

export default () => {
    const language = useLanguage()
    if (!__DEV__) {
        console.debug = console.log = console.warn = console.error = () => {}
    }

    return (
        <div style={{ direction: language === 'he' ? 'rtl' : 'ltr' }}>
            <Grommet theme={grommetTheme} className="App">
                <ModalProvider>
                    <NavigationRouter />
                </ModalProvider>
            </Grommet>
        </div>
    )
}

//export default App
